import React from 'react';
import clsx from 'clsx';
import Helmet from 'react-helmet';
import { useTranslation } from 'react-i18next';

import { makeStyles } from '@material-ui/core/styles';
import { Container } from '@material-ui/core';

import Footer from './Footer';
import Header from './Header';

const useStyles = makeStyles(theme => {
  const minWidth = mq => `@media (min-width: ${theme.breakpoints.values[mq]}px)`;
  const maxWidth = mq => `@media (max-width: ${theme.breakpoints.values[mq]}px)`;

  return {
    root: {
      display: 'flex',
      flexDirection: 'column',
      minHeight: '100vh',
      '& > :last-child': {
        marginTop: 'auto',
      },
    },
    main: {
      [minWidth('md')]: {
        marginTop: '1rem',
        marginBottom: '2rem',
      },
    },
    mainContent: {
      [maxWidth('md')]: {
        padding: 0,
        margin: 0,
      },
    },
  };
});

const Layout = ({ title = 'Climat HD / Météo France', noHeader, noFooter, isHome = false, containerClassName, rootClassName, ...rest }) => {
  const classes = useStyles();
  const [, { language }] = useTranslation();

  const showHeader = noHeader !== true;
  const showFooter = noFooter !== true;

  return (
    <div className={clsx(classes.root, rootClassName)}>
      <Helmet
        htmlAttributes={{ lang: language }}
        title={title}
        link={[
          { rel: 'icon', type: 'image/bmp', sizes: '16x16', href: '/favicon.bmp' },
        ]}
      />

      {showHeader && (
        <Header
          isHome={isHome}
        />
      )}

      <Container
        component="main"
        className={clsx(classes.main, containerClassName, { [classes.mainContent]: !isHome })}
        {...rest}
      />

      {showFooter && <Footer />}
    </div>
  );
};

export default Layout;
